import { FuelIcon } from '@frete.com/fuel-react'
import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
`

export const Icon = styled(FuelIcon)`
  cursor: pointer;
  color: ${({ theme }) => theme.color.icon.neutral.default};
  font-size: ${({ theme }) => theme.font.size.m3};
`
